import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const CreatingInvoiceModal = ({ isOpen }) => {
  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader>
        <h3>Creating Invoices</h3>
      </ModalHeader>
      <ModalBody>
        <p>
          Please wait while invoices are being created. This process may take a few minutes, and you will be redirected automatically once all invoices have been successfully generated.
        </p>
        <div className='my-2'>
          <ReactLoading size="sm" className="loading-spinner m-auto" type="spin" color="black" />
        </div>
      </ModalBody>
    </Modal>
  );
};

CreatingInvoiceModal.propTypes = {
  isOpen: PropTypes.bool,
};

CreatingInvoiceModal.defaultProps = {
  isOpen: false,
};

export default CreatingInvoiceModal;

